import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FileDown, Printer } from 'lucide-react';
import { toast } from 'sonner';
import { download, fetchText } from '@/lib/api';
import { Spinner, ErrorBox } from '@/ui/Spinner';

/** Sunucuda üretilen belge çıktısının (ReportBuilder şablonu → HTML) önizlemesi; yazdır ve PDF indir */
export function HtmlOnizleme({ url, title }: { url: string; title?: string }) {
  const q = useQuery({ queryKey: ['html', url], queryFn: () => fetchText(url), staleTime: 0 });
  const frame = useRef<HTMLIFrameElement>(null);
  const pdfUrl = url + (url.includes('?') ? '&' : '?') + 'format=pdf';
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-2 p-2">
      <div className="panel flex items-center gap-1.5 rounded px-2 py-1.5">
        <button className="btn btn-primary" disabled={!q.data} onClick={() => frame.current?.contentWindow?.print()}><Printer size={14} /> Yazdır</button>
        <button className="btn" disabled={!q.data} onClick={() => download(pdfUrl, undefined, `${title ?? 'belge'}.pdf`, 'GET').catch((e) => toast.error(e.message))}><FileDown size={14} /> PDF</button>
      </div>
      <div className="panel relative min-h-0 flex-1 overflow-hidden rounded">
        {q.isLoading ? <Spinner label="Belge hazırlanıyor…" /> : q.error ? <ErrorBox error={q.error} /> : (
          <iframe ref={frame} title={title ?? 'Belge'} className="h-full w-full border-0 bg-[#e5e7eb]" srcDoc={q.data} sandbox="allow-same-origin allow-modals" />
        )}
      </div>
    </div>
  );
}
